//@flow

import React from "react";

import { BackNavigation } from "@/components";
import ArrowForwardIcon from "@/images/ArrowForward.inline.svg";

type Props = {
    name: string,
    banner: string,
    logo?: string,
    logoLarge?: boolean,
    backgroundPosition: string,
    backButtonText?: string,
    path?: string,
    bannerText?: string,
    bannerLarge?: boolean,
    bannerStyle?: string,
    link?: {
        path: { publicURL: string },
        text: string,
        target?: string,
    },
};

const BrandPageHeader = (
    {
        name,
        logo,
        logoLarge,
        banner,
        backgroundPosition,
        backButtonText,
        path,
        bannerText,
        bannerLarge,
        bannerStyle,
        link
    }: Props,
): React$Element<"div"> => {
    const style = {
        backgroundImage: `url('${banner}')`,
    };

    const brandLogoAlt = `Brand logo ${name}`;

    return (
        <div className="brand-page-header">
            <div className="navigation container my-4 pb-xl-2">
                <h1 className="sr-only">{name}</h1>

                <BackNavigation
                    path={path ? path : "/products-and-brands#our-brands"}
                    name={name}
                    text={backButtonText && backButtonText}
                />

                <div className="spacer" />

                {logo !== undefined && (
                    <div
                        className={
                            logoLarge
                                ? "brand-logo-wrapper-large"
                                : "brand-logo-wrapper"
                        }
                    >
                        <img
                            src={logo}
                            alt={brandLogoAlt}
                            className="brand-logo mb-1"
                        />
                    </div>
                )}
            </div>

            <div
                className={`banner visual ${
                    bannerLarge ? "height-md-fluid" : "height-sm-fluid"
                } ${backgroundPosition} ${bannerStyle ? bannerStyle : ""}`}
                style={style}
            >
                {(bannerText || link) && (
                    <div className="container pt-3 pt-sm-5 position-relative">
                        <h1 className="text-white mb-0">{bannerText}</h1>

                        {link && (
                            <a
                                href={link.path.publicURL}
                                className={
                                    "continue-link boxed-light mt-3 mt-md-4"
                                }
                                target={link.target}
                                rel="noreferrer"
                                key="B"
                            >
                                {link.text}
                                <div className="svg-box icon-sm transition icon-forward">
                                    <div className="svg-container">
                                        <ArrowForwardIcon />
                                    </div>
                                </div>
                            </a>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default BrandPageHeader;
